<div class="acs-page-shell">
  <aside class="acs-side-menu" [class.acs-side-menu--collapsed]="isCollapsed" aria-label="Admin sections">
    <button type="button"
            class="acs-side-menu__toggle"
            (click)="toggleCollapsed()"
            [attr.title]="isCollapsed ? 'Expand menu' : 'Collapse menu'"
            [attr.aria-label]="isCollapsed ? 'Expand menu' : 'Collapse menu'">
      <i class="fa-solid" [class.fa-chevron-right]="isCollapsed" [class.fa-chevron-left]="!isCollapsed"></i>
    </button>
    <div class="acs-side-menu__items">
      <button *ngFor="let tab of tabs"
              type="button"
              class="acs-side-menu__item"
              [class.acs-side-menu__item--active]="isActive(tab.route)"
              (click)="navigateTo(tab.route)"
              [attr.title]="tab.title">
        <i class="fa-solid {{tab.icon}} acs-side-menu__icon"></i>
        <span class="acs-side-menu__label">{{tab.title}}</span>
      </button>
    </div>
  </aside>
  <main class="acs-page-content">
    <header class="acs-page-content__header">
      <h2 class="acs-page-content__title">{{activeTab?.title}}</h2>
    </header>
    <div class="acs-page-content__body">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
